import text from './text.json'
import Input from '../../components/core/input'
import Textarea from '../../components/core/textarea'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {Formik} from 'formik'
import {useState} from 'react'
import {automationSchema} from '../../utils/validation'
import {useDispatch} from 'react-redux'
import {updateAutomation} from '../../stores/automation'
import CustomSelect from '../../components/core/customSelect'
import {trimStringValues} from '../../utils/text'

const UpdateAutomation = ({closePopup, events, automation, setClickedAutomation}) => {
    const [isProcessing, setIsProcessing] = useState(false)
    const [active, setActive] = useState(null)
    const triggers = events?.map(event => {
        return {
            label: event?.name,
            value: event?.key
        }
    })

    const dispatch = useDispatch()

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    const initialFormValues = {
        name: automation?.name,
        description: automation?.description,
        events: automation?.events.map(event => {
            return {
                value: event?.key,
                label: event?.name
            }
        })
    }

    const fieldNames = {
        name: 'name',
        description: 'description',
        events: 'events'
    }

    const editAutomation = async(values, {resetForm, setFieldError}) => {
        const formData = {...values, events: values.events.map(item => item?.value)}
        setIsProcessing(true)
        const success = await dispatch(updateAutomation(automation?.id, trimStringValues(formData), setFieldError))
        setIsProcessing(false)
        setClickedAutomation(null)
        if (success) {
            resetForm()
            closePopup()
        }
    }

    return (
        <div className="modal-body">
            <Formik initialValues={initialFormValues}
                enableReinitialize={true}
                onSubmit={editAutomation}
                validationSchema={automationSchema}
                validateOnBlur={false}
                validateOnChange={false}>
                {({values, errors, handleSubmit, setFieldValue, handleChange}) => (
                    <form onSubmit={handleSubmit} className="modal-body">
                        <Input
                            type="text"
                            value={values.name}
                            placeholder={text.name}
                            name={fieldNames.name}
                            onChange={e => {
                                handleChange(e)
                                setFieldValue('name', e.target.value)
                            }}
                            infoText={text.name_info}
                            activeInfo={active === fieldNames.name}
                            handleInfo={(state) => handleInfo(fieldNames.name, state)}
                            error={errors.name}
                        />
                        <Textarea
                            type="text"
                            value={values.description}
                            placeholder={text.description}
                            name={fieldNames.description}
                            onChange={e => {
                                handleChange(e)
                                setFieldValue('description', e.target.value)
                            }}
                            infoText={text.description_info}
                            activeInfo={active === fieldNames.description}
                            handleInfo={(state) => handleInfo(fieldNames.description, state)}
                            error={errors.description}
                            minLength={3}
                        />
                        <CustomSelect
                            placeholder={text.triggers}
                            onChange={setFieldValue}
                            isMulti
                            infoText={text.triggers_info}
                            name={fieldNames.events}
                            value={values.events}
                            options={triggers}
                            activeInfo={active === fieldNames.events}
                            handleInfo={(state) => handleInfo(fieldNames.events, state)}
                            error={errors.events}/>
                        <SimpleBlueButton
                            type="submit"
                            disabled={isProcessing}>
                            {isProcessing && <ButtonLoader/>}
                            {text.submit}
                        </SimpleBlueButton>
                    </form>
                )}
            </Formik>
        </div>
    )
}

export default UpdateAutomation
